// extracted by mini-css-extract-plugin
export default {"wrapper":"Popper_wrapper__H1Yks","action-wrapper":"Popper_action-wrapper__cUKRv"};